import { Typography, Grid, Collapse } from '@mui/material';
import MainCard from 'components/MainCard';
import { SearchFilterActivity } from './components';
import { RecentActivityList } from './components/RecentActivityList';
import { NoActivityIndicator } from './no-activity-indicator';
import { ActivityLoading } from './activity-loading';
import { useCollapsiblePanel } from 'hooks/use-collapsible-panel';
import ExpandMore from 'components/ExpandMore';

const RecentActivity = () => {
  const { isExpanded, toggle, isCollapsible } = useCollapsiblePanel('dashboard-recent-activity-expanded');

  return (
    <MainCard
      contentSX={{ p: isExpanded ? 2.25 : 0 }}
      secondary={isCollapsible ? <ExpandMore expanded={isExpanded} onExpand={toggle} aria-label="Toggle recent activity" /> : undefined}
      title={
        <Grid container>
          <Grid item xs>
            <Typography variant="h5">Recent Activity</Typography>
          </Grid>
        </Grid>
      }
      style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'start', position: 'relative' }}
    >
      <Collapse in={isExpanded} timeout="auto">
        <div aria-hidden={!isExpanded} style={{ visibility: isExpanded ? 'visible' : 'hidden' }}>
          <SearchFilterActivity />
          <MainCard
            sx={{ display: 'flex', minHeight: '565px', maxHeight: '565px', overflowY: 'auto' }}
            id="activityScroller"
            content={false}
          >
            <RecentActivityList />
            <NoActivityIndicator />
            <ActivityLoading />
          </MainCard>
        </div>
      </Collapse>
    </MainCard>
  );
};

export default RecentActivity;
